import "../teasers.js";

window.Sparkle ??= {};
window.Sparkle.MobileCTA ??= {};

Sparkle.MobileCTA.TeaserInline = class TeaserInline extends Sparkle.MobileCTA.Teasers {};
Sparkle.MobileCTA.TeaserInline.prototype.className = "mobile-teaser-inline-wrapper";
